
import { useMemo } from 'react';

import {
  useCancelSubscriptionModalQuery,
  useCancelSubscriptionMutation
} from 'generated/graphql';
import { useLoading } from 'modules/layer0';
import moment from 'moment';



export function useCancelSubscriptionModal() {
  const tuple = useCancelSubscriptionModalQuery();

  const [cancelSubscription, cancelSubscriptionTuple] = __useCancelSubscriptionMutation();
  const loading = useLoading([tuple, cancelSubscriptionTuple]);

  const data = useMemo(() => ({
    willCancelAtPeriodEnd: tuple.data?.loggedInUser?.subscriptionInfo?.willCancelAtPeriodEnd ?? false,
    hasSubscription: tuple.data?.loggedInUser?.subscriptionInfo?.status === 'active',
    periodEnd: moment(tuple.data?.loggedInUser?.subscriptionInfo?.currentPeriodEnd)
  }), [tuple]);


  return {
    loading,
    data,
    mutations: {
      cancelSubscription
    }
  };
}



function __useCancelSubscriptionMutation() {
  const [fnMutate, tuple] = useCancelSubscriptionMutation();

  async function fnWrappedMutate() {
    await fnMutate();
  }

  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}
